module.exports = __webpack_public_path__ + "img/happy.cde9ed6f.svg";